import bingPixelStr from './cookie-trackers/site-wide/bing-pixel.js?raw';
import googleTagStr from './cookie-trackers/site-wide/google-tag.js?raw';
import impactPixelStr from './cookie-trackers/site-wide/impact-pixel.js?raw';
import linkedinTrackingStr from './cookie-trackers/site-wide/linkedin-tracking.js?raw';
import metaPixelStr from './cookie-trackers/site-wide/meta-pixel.js?raw';
import microsoftClarityStr from './cookie-trackers/site-wide/microsoft-clarity.js?raw';
import redditPixelStr from './cookie-trackers/site-wide/reddit-pixel.js?raw';
import { type CookieTrackers, strToInlineScript } from './seo';
import { shouldDisableTrackers } from './tracker-suppression';

// ProfitWell Retain was removed 2026-07 (WEB-ER): Retain is not
// enabled on our Paddle/ProfitWell account, so identified sessions
// 403'd on every signed-in marketing visit. If Retain is ever enabled,
// restore `cookie-trackers/site-wide/profitwell-retain.ts` from git
// history — but NOT the `customerId` SSR-loader plumbing that fed it;
// Paddle supports deferring `profitwell('start', …)` until identity
// loads, so re-enable it client-side (see `_marketing.tsx`).
//
// Takes no arguments, deliberately — ProfitWell was the only site-wide
// tracker with an identify-on-init API. Every remaining script here is a
// static string, which is what lets marketing responses be CDN-cached:
// nothing per-user reaches the HTML.
//
// If a future tracker needs user identity, resolve it CLIENT-SIDE after
// hydration rather than reintroducing an SSR loader — an id baked into
// shared-cached HTML is served to whoever gets that cache entry next.
//
// Mounted from `__root.tsx`, so every document — marketing, funnel, app,
// `/post-purchase` — boots these once; the vendors' own history listeners
// cover client-side navigations. Both Google and Meta want their tag on
// every page a visitor can land on: the Google Ads tag is what stores a
// `gclid` in `_gcl_aw` on the landing so a later conversion can be
// attributed, and it runs on every route only if it lives here. Per-page
// content events (`ViewContent` and friends) stay in
// `cookieTrackersLanding()` on `_marketing`.
export function cookieTrackersSiteWide(): CookieTrackers {
  if (shouldDisableTrackers()) return [];

  const rawScripts = [
    googleTagStr,
    impactPixelStr,
    bingPixelStr,
    linkedinTrackingStr,
    metaPixelStr,
    redditPixelStr,
    microsoftClarityStr,
  ].map(strToInlineScript);
  return [
    {
      async: true,
      src: 'https://www.googletagmanager.com/gtag/js?id=AW-11198534691',
    },
    ...rawScripts,
  ];
}

// <!--   lis-ext: site-wide.html   -->
// <ImpactPixel />
// <BingPixel />
// <LinkedinTracking />
// <MetaPixel />
// <RedditPixel />
// <MicrosoftClarity />

// <!--   lis-ext: site-wide.html   -->
